<script>
    import { onMount } from "svelte";
    import { writable } from 'svelte/store';
    import { getWorkList, dialogType, dialogMessage, showDialog, workListResponse } from "../http.js";

    import WorkerList from "./WorkerList.svelte";
    import PiecesTable from "./PiecesTable.svelte";
    import DataViewer from "./DataViewer.svelte";
    import Loader from "./Loader.svelte";
    import Notification from "./Notification.svelte";

    let toggleLoader = true;
    let activeTab = "workers"; // "workers", "pieces", or "data"

    let dialog;
    let message;
    let type;

    showDialog.subscribe(value => {
        dialog = value;
    });

    dialogMessage.subscribe(value => {
        message = value;
    });

    dialogType.subscribe(value => {
            type = value;
    });

    onMount(async () => {
        try {
            const response = await getWorkList();
            workListResponse.set(response);
            toggleLoader = false;

        } catch (error) {
            showDialog.update(true);
            dialogType.update("is-danger");
            dialogMessage.update("Nie możemy pobrać danych. Spróbuj ponownie.");
        };
    });

    const switchTab = (tab) => {
        activeTab = tab;
    };
</script>

<section aria-label="Panel sterowania">
    <div class="pageloader is-success {toggleLoader === true ? 'is-active': ''}">
        <span class="title">Pobieramy dane pracowników...</span>
    </div>

    {#if dialog}
        <Notification dialogType={type} dialogMessage={message}/>
    {/if}

    <div class="tab-bar" role="tablist" aria-label="Widoki panelu">
        <button type="button" role="tab" class="tab-pill" class:is-active={activeTab === 'workers'}
            aria-selected={activeTab === 'workers'} on:click={() => switchTab('workers')}>Pracownicy</button>
        <button type="button" role="tab" class="tab-pill" class:is-active={activeTab === 'pieces'}
            aria-selected={activeTab === 'pieces'} on:click={() => switchTab('pieces')}>Dzieła</button>
        <button type="button" role="tab" class="tab-pill" class:is-active={activeTab === 'data'}
            aria-selected={activeTab === 'data'} on:click={() => switchTab('data')}>Dane</button>
    </div>

    <div class="section-body">
        <Loader state={toggleLoader}/>
        {#if activeTab === 'workers'}
            <WorkerList response={workListResponse}/>
        {:else if activeTab === 'pieces'}
            <PiecesTable />
        {:else if activeTab === 'data'}
            <DataViewer />
        {/if}
    </div>
</section>
